export default "__VITE_ASSET__4N8ztvp1__"